module.exports = __webpack_public_path__ + "img/coach.5dfdce90.svg";